module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title-head",
    attrs: {
      "id": "Intro"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The Cherokee knew the land around Winston Salem was good. They hunted wooly buffalo and deer and fished in the river. Their ancestors lived undisturbed on the land for over eight thousand years. They coexisted with creatures of all kinds, including bigfoot, some say.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Moravians—German Protestants—came next. They thought the land was a peaceful haven, away from those who would punish them for their religion. They were brave people, afraid of nothing but the devil. That’s why they didn’t like the caves on the land. Some thought the devil might be skulking in one of the tunnels.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Winston Salem, to the naked eye, might look like a peaceful. However, if you dig further, peek into windows, and listen, you’ll find it full of curses, witches, and ghosts.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("So, when you visit (or if you are lucky enough to live in Winston-Salem), pay attention. Pause by old wells and listen. Besides the trickle of water, will you hear the strange chants of Druid monks? If you rise before the sun on market days, will you see a horse and wagon that stopped running over a hundred years ago? Sit outside one of the old houses after the sun sets. You might see a little old lady peeking out the window at you. Enjoy the thrill, for none of those supernatural events could harm you. But if a blood red painting appears in your house, run! That’s the one mystery of Winston-Salem no one wants to solve.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/P8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/P10.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-374f0a11","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Introduction.vue
// module id = 75
// module chunks = 0